import { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface Seniority {
    id: string;
    name: string;
}

export const useSeniorities = () => {
    const [seniorities, setSeniorities] = useState<Seniority[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchSeniorities = async () => {
            try {
                const senioritiesCollection = collection(db, 'seniorities');
                const q = query(senioritiesCollection, orderBy('name'));
                const querySnapshot = await getDocs(q);
                const senioritiesList = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                })) as Seniority[];
                setSeniorities(senioritiesList);
            } catch (err) {
                console.error("Error fetching seniorities:", err);
                setError('Falha ao buscar senioridades.');
            } finally {
                setLoading(false);
            }
        };

        fetchSeniorities();
    }, []);

    return { seniorities, loading, error };
}; 